//@ts-nocheck
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  urlAgendamentosDiaEmpresas,
  urlInfoContaEmpresas,
} from "../../../utils/constants";
import axiosClient from "../../../utils/axiosClient";
import MenuSide from "../../../components/empresas/MenuSide";
import CalendarioSemanaEmpresas from "../calendario";
import {
  IonItem,
  IonLabel,
  IonContent,
  IonList,
  IonPage,
  IonBadge,
  IonCard,
  IonButton,
  IonChip,
} from "@ionic/react";
import HeaderApp from "../../../components/global/HeaderItem";
import StatusAgendamento from "../../../components/global/StatusAgendamento";
import DashboardEmpresas from "../dashboard";
import { useNavigate, createSearchParams } from "react-router-dom";
import moment from "moment";
import "moment/locale/pt-br";

moment().locale("pt-br");

export default function InicioUsuario() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [infoUsuario, setInfoUsuario] = useState([]);
  const navigate = useNavigate();

  const consultaConta = async () => {
    try {
      const response = await axiosClient.post(urlInfoContaEmpresas, {});
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const consultarAgendamentosDia = async () => {
    try {
      const response = await axiosClient.post(urlAgendamentosDiaEmpresas, {});
      return response.data.agendamentos_dia;
    } catch (error) {
      console.log(error);
    }
  };

  const consultarItens = async () => {
    const lista = await consultarAgendamentosDia();
    setAgendamentos(lista);
  };

  useEffect(() => {
    consultarItens();
    const run = async () => {
      const infoUsuario = await consultaConta();
      setNomeUsuario(infoUsuario.nome);
      setInfoUsuario(infoUsuario);
    };
    run();
  }, []);

  return (
    <IonPage  id="main-content">
      <IonContent>
        {Array.isArray(agendamentos) && (
          <div>
            <div>
              <div>
                <div className="container">
                  <div className="ion-margin ion-text-center">
                    <h5 className="CapitalizarTexto">Olá, {nomeUsuario}</h5>
                  </div>
                  <div className="rowTripleCards">
                    <div className="colTripleCards">
                      <IonCard
                        color="secondary-light"
                        onClick={() => {
                          navigate({ pathname: "/empresas/agendar" });
                        }}
                        button={true}
                        className="tripleCard"
                      >
                        <div className="containerTripleCard">
                          <div>
                            <IonButton
                              className="buttonTripleCard"
                              color="light"
                            >
                              <i className="ri-add-line colorIconTripleCard"></i>
                            </IonButton>
                          </div>
                          <h6 className="textoTripleCard">Agendar horário</h6>
                        </div>
                      </IonCard>
                    </div>
                    <div className="colTripleCards">
                      <IonCard
                        color="secondary-light"
                        onClick={() => {
                          navigate({ pathname: "/empresas/calendario" });
                        }}
                        className="tripleCard"
                      >
                        <div className="containerTripleCard">
                          <div>
                            <IonButton
                              className="buttonTripleCard"
                              color="light"
                            >
                              <i className="ri-calendar-todo-line colorIconTripleCard"></i>
                            </IonButton>
                          </div>
                          <h6 className="textoTripleCard">Calendário</h6>
                        </div>
                      </IonCard>
                    </div>
                    <div className="colTripleCards">
                      <IonCard
                        color="secondary-light"
                        onClick={() => {
                          navigate({ pathname: "/empresas/inicio-custom" });
                        }}
                        button={true}
                        className="tripleCard"
                      >
                        <div className="containerTripleCard">
                          <div>
                            <IonButton
                              className="buttonTripleCard"
                              color="light"
                            >
                              <i className="ri-more-line colorIconTripleCard"></i>
                            </IonButton>
                          </div>
                          <div>
                            {" "}
                            <h6 className="textoTripleCard">Mais opções</h6>
                          </div>
                        </div>
                      </IonCard>
                    </div>
                  </div>
                </div>

                <CalendarioSemanaEmpresas retornaData={(data) => setDataAgendamento(data)} />
              </div>
            </div>
          </div>
        )}
        <DashboardEmpresas dataSelecionada={dataAgendamento} />
        <MenuSide />
      </IonContent>
    </IonPage>
  );
}
